import { Constants } from '../constants';
import { AddressDto } from '../model/business/AddressDto';
import { AddressTypeEnum } from '../model/enums/AddressTypeEnum';
import { InsuredDetails } from '../model/business/application/InsuredDetails';

export function replaceThousandSeparatorAndRemovingEuroPrefix(value: number | string, separator: string = Constants.THOUSAND_SEPARATOR): number {
  const regexp = new RegExp('\\' + separator, 'g');
  const valueReplaced = value.toString().replace(regexp, '').replace('€', '').trim();
  return Number(valueReplaced);
}

export function openPDFFromByteCharacters(byteCharacters: string, fileName: string): void {
  const byteArray = new Uint8Array(
    atob(byteCharacters)
      .split('')
      .map((char) => char.charCodeAt(0))
  );
  const blob = new Blob([byteArray], {type: 'application/pdf'});
  openBlob(blob, fileName);
}

export function openBlob(blob: Blob, fileName: string): void {
  const nav = (window.navigator as any);
  if (nav && nav.msSaveOrOpenBlob) {
    nav.msSaveOrOpenBlob(blob, fileName);
    return
  }
  const fileURL = URL.createObjectURL(blob);
  window.open(fileURL);
}

export function getDutchAddress(insured: InsuredDetails): AddressDto {
  const addressDto = new AddressDto();
  addressDto.addressType = AddressTypeEnum.AddressDutch;
  addressDto.dutchStreet = insured.street;
  addressDto.dutchZipCode = insured.zipCode?.toUpperCase();
  addressDto.dutchCity = insured.city;
  addressDto.dutchNumber = insured.houseNumber;
  addressDto.dutchSuffix = insured.houseNumberSuffix;
  return addressDto;
}

export function getValueFromCurrencyInput(value: string = '') {
  return value.replace(/€\s*(\d+)/, "$1");
}
